import { useCallback } from 'react';
import Row from './Row.js';
import { getListStyles } from './ListStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const List = _ref => {
  let {
    dropOffList,
    onChangeHover,
    ...props
  } = _ref;
  const onMouseEnter = useCallback(id => onChangeHover(id), [onChangeHover]);
  const onMouseLeave = useCallback(() => onChangeHover(), [onChangeHover]);
  return jsx("ul", {
    onMouseLeave: onMouseLeave,
    css: getListStyles,
    children: dropOffList.map(dropOff => jsx(Row, {
      dropOff: dropOff,
      onMouseEnter: onMouseEnter,
      ...props
    }, dropOff.id))
  });
};
List.displayName = 'PudoList';
var List$1 = List;

export { List$1 as default };
//# sourceMappingURL=List.js.map
